import { lazyOpenBizChatSidePane } from "owa-bizchat-shared";
import { type LocalizedString } from "owa-localize";
import type { OpenBizChatSidePaneParams } from "owa-bizchat-types";
import type { MailboxInfo } from "owa-client-types";

export type OpenChatPaneOptions = {
    params?: Partial<OpenBizChatSidePaneParams>;
    promptText: LocalizedString;
    targetWindow: Window;
    mailboxInfo: MailboxInfo;
};

/**
 * Opens the Copilot chat side pane with the specified prompt text and DAB source attribution.
 */
export const openChatPane = ({ params, promptText, targetWindow, mailboxInfo, }: OpenChatPaneOptions): void => {
    lazyOpenBizChatSidePane.importAndExecute({
        ...params,
        isNewChat: true,
        promptText,
        targetWindow,
        source: "CopilotDabRibbonSUA",
        mailboxInfo,
    });
};
